export default function marketo(formContainer) {
	"use strict";

	MktoForms2.whenReady(function (form) {
		let formEl = form.getFormElem(),
			submitButton = formEl.find(".mktoButtonRow button[type='submit']"),
			random = "_" + Math.round(Math.random() * 100);

		let recaptchaEnabled =
			typeof formEl.closest(formContainer).data("enable-recaptcha") !==
			"undefined"
				? $(formContainer).data("enable-recaptcha")
				: false;
		let successMessageId =
			typeof formEl.closest(formContainer).data("success-id") !== "undefined"
				? $(formContainer).data("success-id")
				: false;

		//Create unique IDs for fields
		formEl.find("label[for]").each(function () {
			let labelHTML = $(this).attr("for");
			$(this).attr("for", labelHTML + random);

			formEl
				.find('input[id="' + labelHTML + '"]')
				.attr("id", labelHTML + random);
		});

		//If recaptcha is enabled setup form
		if (recaptchaEnabled) {
			//The form will be form unsubmittable until captcha is done
			form.submittable(false);
		}

		$(".mktoCheckboxList").each(function () {
			var count = $(this).children("input").length;

			if (count <= 1) {
				$(this)
					.parent()
					// .addClass("checkbox-style");
					.addClass("marketo__checkbox");
				$(this).closest(".mktoFormRow").addClass("marketo__checkbox-row");
			}
		});

		if ($("select.mktoField").length > 0) {
			$("select.mktoField").select2();
		}

		if ($("textarea.mktoField").length > 0) {
			$("textarea.mktoField").closest(".mktoFormRow").addClass("mktoClear");
		}

		$("input[type='hidden']").each(function () {
			$(this).closest(".mktoFormRow").hide();
		});

		$('input[type="checkbox"]').iCheck({
			checkboxClass: "icheckbox_minimal-grey",
			aria: true,
		});

		if (recaptchaEnabled) {
			$("button[type='submit']").on("click", function () {
				$(this).attr("disabled", "disabled").html("Please Wait");

				if (form.validate()) {
					grecaptcha.ready(function () {
						var urlPath = window.location.pathname;
						urlPath = urlPath.replace("-", "_");
						grecaptcha
							.execute("6Ldf9rkUAAAAANGLwI2AJl1QCQkEMPoTqn9_8fjl", {
								action: urlPath,
							})
							.then(function (token) {
								form.addHiddenFields({
									lastRecaptchaUserInput: token,
								});
								form.submittable(true);
								form.submit();
							});
					});
				}
			});
		}

		form.onValidate(function (builtInValidation) {
			// Die if validation failed
			if (!builtInValidation) {
				return false;
			}
		});

		// Add an onSuccess handler
		form.onSuccess(function (values, followUpUrl) {
			const scrollToSuccessMessageId =
				document.getElementById("js-marketo-form").dataset
					.scrollToSuccessMessage;
			const showSuccessMessageId =
				document.getElementById("js-marketo-form").dataset.showSuccessMessage;

			if (scrollToSuccessMessageId) {
				const successEl = document.getElementById(showSuccessMessageId);

				successEl.classList.remove("hidden");

				const sectionTop = successEl.offsetTop;

				window.scrollTo({
					top: sectionTop,
					behavior: "smooth",
				});
			} else if (showSuccessMessageId) {
				const successEl = document.getElementById(showSuccessMessageId);
				const formEl = document.getElementById("js-marketo-form");
				const sectionTop = formEl.offsetTop;

				window.scrollTo({
					top: sectionTop,
					behavior: "smooth",
				});

				successEl.classList.remove("hidden");
				formEl.classList.add("hidden");
			} else {
				let url =
					location.protocol +
					"//" +
					document.domain +
					document.location.pathname +
					"?r=success";

				// Add success message id if available
				if (successMessageId) {
					url = url + "&i=" + successMessageId;
				}

				// Take the lead to a different page on successful submit, ignoring the form's configured followUpUrl
				location.href = url;
			}
			// Return false to prevent the submission handler from taking the lead to the follow up url
			return false;
		});
	});
}
